
















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { stringToBig } from '@/helper'

@Component({})
export default class AssetResult extends Vue {
    @Prop() item!: any

    get id() {
        return `${this.item.id}`
    }

    get idAbbreviated() {
        return `${this.item.id.substring(0, 8)}...`
    }

    get name() {
        return this.item.name
    }

    get symbol() {
        return this.item.symbol
    }

    get supply() {
        return stringToBig(this.item.currentSupply, this.item.denomination)
    }

    select() {
        const url = `/asset/${this.id}`
        this.$router.push(url)
        this.$emit('select')
    }
}
